import BoardPart, {
  PlacementTypeChoices
} from 'src/app/model/product/board/board-part';
import PlacementType from 'src/app/model/product/board/placement-type';

export class BoardPartFormHelper {
  private constructor() {}

  private static readonly NO_DISTANCE_PLACEMENT_TYPES: PlacementType[] = [
    PlacementTypeChoices.ATTACHED_TO_FACADE,
    PlacementTypeChoices.STRETCHED
  ];

  static calculateShowDistanceToBottomSelector(boardPart: BoardPart): boolean {
    return (
      boardPart.placementType == null ||
      !BoardPartFormHelper.NO_DISTANCE_PLACEMENT_TYPES.some(
        t => t.ordinal === boardPart.placementType.ordinal
      )
    );
  }
}
